import React from 'react';
import { BrowserRouter, Link } from 'react-router-dom';
import Router from "./Router";

function App() {
  return (
    <BrowserRouter>
      <div className="container">
        <header>
          <div className="inner">
            <h1>
              <Link to="/"><b>바른</b> 법무사 사무소</Link>
            </h1>
          </div>
        </header>
        <main>
          <Router></Router>
        </main>
        <footer>
          <div className="inner">
            <div>상담예약문의 : <a href="tel:02-448-2207">02-448-2207</a></div>
            <div>
              <a href="https://blog.naver.com/lawbareun" className="btn-naverBlog" target="blank">블로그</a>
            </div>
          </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
